import React, { useState } from 'react'
import Img from 'gatsby-image'
import Slider from "react-slick"
import v4 from 'uuid/v4'

const settings = {
	dots: false,
	infinite: false
}

const Galery = ({ attrs, images }) => {
	const [currentSlide, setCurrentSlide] = useState(0)
	// Validation des props
	if (!attrs || !attrs.items || !Array.isArray(attrs.items) || attrs.items.length === 0) {
		return (
			<div role="alert" aria-live="polite" className="galery-error">
				Aucune image trouvée dans la galerie
			</div>
		)
	}

	if (!images || !Array.isArray(images)) {
		return (
			<div role="alert" aria-live="polite" className="galery-error">
				Images non disponibles
			</div>
		)
	}

	// Filtrage des éléments valides
	const validItems = attrs.items.filter(({ imageid }) => {
		if (!imageid || imageid === 0) return false
		const img = images.find(({ wordpress_id }) => wordpress_id === imageid)
		return img && img.localFile && img.localFile.childImageSharp && img.localFile.childImageSharp.sizes
	})

	if (validItems.length === 0) {
		return (
			<div role="alert" aria-live="polite" className="galery-error">
				Aucune image valide trouvée
			</div>
		)
	}

	const renderSlide = ({ imageid, legend, link }) => {
		const img = images.find(({ wordpress_id }) => wordpress_id === imageid)
		const imageSharpSizes = img.localFile.childImageSharp.sizes
		const altText = legend ? `Image : ${legend}` : `Image ${imageid}`

		const slideContent = (
			<>
				<Img sizes={imageSharpSizes} alt={altText} role="img" aria-hidden="false" />
				{legend && (
					<div className="slide-bottom" aria-label="Légende de l'image">
						<p>{legend}</p>
					</div>
				)}
			</>
		)

		if (link) {
			return (
				<a
					href={link}
					target="_blank"
					rel="noopener noreferrer"
					aria-label={`${altText} (s'ouvre dans un nouvel onglet)`}
				>
					{slideContent}
				</a>
			)
		}

		return slideContent
	}

	return (
		<div
			className="carousel slideshow"
			role="region"
			aria-label={`Galerie d'images avec ${validItems.length} image${validItems.length > 1 ? 's' : ''}`}
		>
			<div className="visually-hidden" aria-live="polite" aria-atomic="true">
				{`Image ${currentSlide + 1} sur ${validItems.length}`}
			</div>
			<Slider {...settings} afterChange={(index) => setCurrentSlide(index)}>
				{validItems.map((item, index) => (
					<div
						key={v4()}
						className="carousel-slide"
						role="group"
						aria-label={`Image ${index + 1} sur ${validItems.length}`}
					>
						{renderSlide(item)}
					</div>
				))}
			</Slider>
		</div>
	)
}

export default Galery


// import React, { Component } from 'react'
// import Img from 'gatsby-image'
// import { Container } from 'reactstrap'
// import Slider from "react-slick";


// class Galery extends Component {
// 	constructor(props, context) {
// 		super(props, context);

// 		this.state = {
// 			theater: false,
// 			activeItem: null
// 		}

// 		this.handleSlideCLick = this.handleSlideCLick.bind(this)
// 		this.handleCarouselClick = this.handleCarouselClick.bind(this)
// 	}

// 	handleSlideCLick(key){
// 		this.setState({
// 			theater: true,
// 			activeItem: key
// 		})
// 	}

// 	handleCarouselClick(){
// 		if(this.state.theater){
// 			this.setState({
// 				activeItem: null,
// 				theater: false
// 			})
// 		}
// 	}

// 	render(){
// 		const { items } = this.props.attrs

// 		const settings = {
// 	    	dots: false,
// 	    	infinite: false
// 	    }

// 	    let theaterRender = null

// 	    if(this.state.theater && this.state.activeItem !== null){
// 	    	const item = items[this.state.activeItem]
// 	   		const img = item.imageid && item.imageid !== 0 && this.props.images && this.props.images.find(({wordpress_id}) => wordpress_id === item.imageid)
// 	    	theaterRender =
// 	    		<div className="carousel-theater">
// 	    			<div className="content-wrapper">
// 	    				<Container>
// 	    					<div className="content">
// 			    				<Img sizes={img.localFile.childImageSharp.sizes}/>
// 		    				</div>
// 	    				</Container>
// 	    			</div>
// 	    		</div>
// 	    }

// 		return(
// 			<>
// 			{theaterRender}
// 			<div className="carousel slideshow">
// 				<Slider {...settings}>
// 				{
// 		         	items.map((i, key) => {
// 		         		const img = i.imageid && i.imageid !== 0 && this.props.images && this.props.images.find(({wordpress_id}) => wordpress_id === i.imageid)
// 		         		if(img && img.localFile.childImageSharp && img.localFile.childImageSharp.sizes){
// 		         			return(
// 			         			<div key={key} className={`carousel-slide ${(this.state.theater && this.state.activeItem && this.state.activeItem === key ? "full-size" : "")}`}>
// 									<Img sizes={img.localFile.childImageSharp.sizes}/>
// 									<div className="slide-bottom">
// 										<p>{i.legend}</p>
// 									</div>
// 								</div>
// 		         			)
// 		         		}else return null
// 		         	})
// 		        }
// 		        </Slider>

// 			</div>
// 			</>
// 		)
// 	}
// }

// export default Galery;
